@if (termsType(); as type) {
  <mat-card>
    <mat-card-content *fsSkeleton="document()">
      <app-logo></app-logo>
      <h2>{{ type.name }}</h2>
      <div class="subheading">Effective {{ document().effectiveDate | fsDateFormat: 'full-date' }}</div>
      <hr>
      <fs-html-renderer [html]="document().content"></fs-html-renderer>
    </mat-card-content>
  </mat-card>
}
